export function checkDate(date) {
    return /\d{2}\/\d{2}\/\d{4}/.test(date);
}